import React, { createContext } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import { PureLightTheme } from './schemes/PureLightTheme';

export const ThemeContext = createContext({});

const ThemeProviderWrapper = (props) => {
  return (
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={PureLightTheme}>{props.children}</ThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeProviderWrapper;
